import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";

export const examListLoader: LoaderFunction = async () => {
  const result = await axiosApi.get("/api/exams?pageSize=100");

  return result.data;
};
